import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './index.css';
import App from './App';
import AvatarCreation from './AvatarCreation';
import AvatarDisplay from './AvatarDisplay';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/avatar" element={<AvatarCreation />} />
        <Route path="/avatar/display/:visitorId/:avatarId" element={<AvatarDisplay />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
